import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import cx from 'classnames';
import './loading-button.css'; //import PropTypes from 'prop-types';

/**
 * 
 * 
 * @example
 
import LoadingBtn from 'core-own/components/loading-button'
const Test = this.props => {

    
    return (
        <div>
            <LoadingBtn 
                element = 'i'
                
                title={"assign"}
                isLoading={this.props.isLoading}                
            />
        </div>   
    );
};


 */

import PropTypes from 'prop-types';

var LoadingButton = /*#__PURE__*/function (_Component) {
  _inherits(LoadingButton, _Component);

  var _super = _createSuper(LoadingButton);

  function LoadingButton() {
    var _this;

    _classCallCheck(this, LoadingButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      noRight: ""
    });

    return _this;
  }

  _createClass(LoadingButton, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isLoading = _this$props.isLoading,
          title = _this$props.title,
          customIcon = _this$props.customIcon,
          onClick = _this$props.onClick,
          className = _this$props.className,
          disabled = _this$props.disabled,
          permissionDeny = _this$props.permissionDeny,
          permissionDenyText = _this$props.permissionDenyText,
          style = _this$props.style;
      var element = this.props.element ? this.props.element : 'button';
      var loadingLayout = this.props.loadingLayout ? this.props.loadingLayout : "fa fa-spinner fa-spin fa-fw loadingIcon";

      var renderLoading = function renderLoading() {
        if (!isLoading) {
          return null;
        }

        return /*#__PURE__*/React.createElement("i", {
          className: loadingLayout
        });
      };

      var renderPermissionDeny = function renderPermissionDeny() {
        if (permissionDeny && _this2.state.noRight != "") {
          return /*#__PURE__*/React.createElement("div", {
            id: "btn-NoRight",
            className: _this2.props.inputClassName
          }, _this2.state.noRight);
        } else {
          return null;
        }
      };

      var click = onClick;

      if (disabled || permissionDeny || isLoading) {
        click = function click() {};
      }

      var children;
      return /*#__PURE__*/React.createElement(element, {
        className: cx(className, {
          loadingBtn: isLoading
        }, {
          permissionDisableButton: permissionDeny || disabled
        }, {
          btnOpacity: this.state.noRight == "" && permissionDeny || disabled
        }),
        style: style,
        onClick: click,
        // disabled: isLoading || disabled || permissionDeny,
        onMouseEnter: function onMouseEnter() {
          _this2.setState({
            noRight: permissionDenyText || "*Not Allow"
          });
        },
        onMouseLeave: function onMouseLeave() {
          _this2.setState({
            noRight: ""
          });
        },
        role: "button"
      }, [title, renderLoading(), renderPermissionDeny()])
      /*<button className={className} onClick={onClick} disabled={isLoading}>
          {title}
          {renderLoading()}
      </button>*/
      ;
    }
  }]);

  return LoadingButton;
}(Component); // LoadingButton.propTypes = {
//     title: PropTypes.string,
//     isLoading: PropTypes.bool,
//     customIcon: PropTypes.node,
//     onClick: PropTypes.func,
// };


export { LoadingButton };
import i18n from 'i18next';
var tc = i18n.getFixedT(null, 'channels');

var TextLoadingButton = function TextLoadingButton(props) {
  return /*#__PURE__*/React.createElement(LoadingButton, _extends({}, props, {
    //permissionDenyText={"* " + tc('notAllow')}
    permissionDenyText: tc('notAllow')
  }));
};

export default TextLoadingButton;
export function loadingStateHoc(Comp) {
  var Hoc = /*#__PURE__*/function (_Component2) {
    _inherits(Hoc, _Component2);

    var _super2 = _createSuper(Hoc);

    function Hoc() {
      var _this3;

      _classCallCheck(this, Hoc);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this3 = _super2.call.apply(_super2, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this3), "state", {
        isLoading: false
      });

      _defineProperty(_assertThisInitialized(_this3), "handleSubmit", function () {
        _this3.setState({
          isLoading: true
        });

        _this3.props.submit().then(function () {
          _this3.setState({
            isLoading: false
          });
        });
      });

      return _this3;
    }

    _createClass(Hoc, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(Comp, _extends({}, this.props, {
          isLoading: this.state.isLoading,
          submit: this.handleSubmit
        }));
      }
    }]);

    return Hoc;
  }(Component);

  Hoc.propTypes = {
    submit: PropTypes.func.isRequired
  };
  return Hoc;
}